/**
 * Imperative Authorisation Check
 */
export const checkAuthentication = (tenantContext: {
	atlassianAccountId: string | null;
}): boolean => Boolean(tenantContext.atlassianAccountId);
